import type { GetServerSidePropsContext } from "next";

import { loadPageWithGlobal } from "@shared/api";

import type { EventType } from "@/_pages/event/model";
import { getEventsPage } from "@/_pages/events/api";
import type { PageType } from "@/_pages/events/model";
import { EventsPage } from "@/_pages/events/ui";

type PageProps = {
  cms: {
    events: EventType[];
    page: PageType;
  };
};

const Page = ({ cms }: PageProps) => {
  return <EventsPage {...cms} />;
};

export async function getServerSideProps({ res }: GetServerSidePropsContext) {
  return await loadPageWithGlobal(
    async () => {
      return {
        ...(await getEventsPage()),
      };
    },
    { res },
  );
}

export default Page;
